import { Box, Skeleton } from "@mantine/core";
import React from "react";

const ReviewStatusHistorySkeleton = () => {
  return (
    <Box>
      <Skeleton w={200} mt="md" mb="md" h={30} />
      <Skeleton h={160} />
    </Box>
  );
};

export default ReviewStatusHistorySkeleton;
